export default "__VITE_ASSET__D_Qno_MU__";